// If running in development environment, use relative paths so devServer proxy (configured in quasar.conf) handles API routing to avoid CORS issues. Else use the proxy URL or fallback to the app's origin if PROXY_URL is not set.
export const url =
  process.env.NODE_ENV === 'development'
    ? ''
    : process.env.PROXY_URL || window.location.origin;
export const buildEnvironment = process.env.BUILD_ENV || 'dev';
let socketHost =
  window.location.protocol == 'https:'
    ? window.location.hostname
    : (process.env.PROXY_URL || window.location.hostname);
let socketProtocol = window.location.protocol == 'https:' ? 'wss' : 'ws';

if (socketHost && socketHost.includes('//')) {
  socketHost = socketHost.split('//')[1].split(':')[0];
  // socketHost = 'localhost';
}
// Gateway happens here where we route all traffic to our unified endpoint
// Ensure new services get registered here by assigning parameter from express
export const envUrls = {
  scansService: `${url}/scans/`,
  leadershipService: `${url}/leadership/`,
  documentService: `${url}/document/`,
  notesService: `${url}/notes/`,
  partnershipsService: `${url}/partnerships/`,
  usersService: `${url}/users/bluescout/`,
  authService: `${url}/auth/bluescout/`,
  trendsService: `${url}/trends/`,
  collabService: `${url}/collabs/`,
  applicationService: `${url}/`,
  entityService: `${url}/entities/`,
  bluechipService: `${url}/bluechip`,
  bluelensService: `${url}/bluelens`,
  benchmarks: `${url}/benchmarks/`,
  fundingService: `${url}/funding/`,
  trendsService: `${url}/trends/`,
  notification: `${url}/notification/`,
  workspaceService: `${url}/workspace/`,
  emailService: `${url}`,
  url: url,
  SOCKET_URL: `${socketProtocol}://${socketHost}/notification/`,
  // Uncomment for local testing
  // SOCKET_URL: `ws://localhost:6043/sockets`,
};
